import React from "react";
import CardPage from "../../../layout/CardPage";
import { Alert, Col, Row, Spin } from "antd";
import { useGetServicios } from "./useGetServicios";
import { ServicioItem } from "./ServicioItem";

export const SemaforoEscalamiento = () => {
  const { serviciosEscalamiento, loading, error } = useGetServicios();

  if (loading) return <Spin />;
  if (error) return <Alert type="error" message="No se pudo consultar el semáforo de escalamiento" />;

  return (
    <CardPage titulo="Semáforo Escalamiento de Asignacón">
      <Row>
        <Col span={4}>
          <div className="subTitulo">{serviciosEscalamiento.length} casos</div>
        </Col>
      </Row>

      <Row className="TituloTabla">
        <Col xs={8} xxl={2}>
          ID
        </Col>
        <Col xs={8} xxl={3}>
          Llamada termianda
        </Col>
        <Col xs={8} xxl={3}>
          Servicio
        </Col>
        <Col xs={8} xxl={12}>
          Ubicacion
        </Col>
      </Row>

      {serviciosEscalamiento.map((s, i) => (
        <ServicioItem key={s.asistenciaID} servicio={s} />
      ))}
    </CardPage>
  );
};
